import styled from 'styled-components';

import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { centeredFlex } from '../../../styles';

export const TeamLogo = styled(TeamDisplay)<{ $isFaded?: boolean; $isSmall?: boolean }>`
    ${centeredFlex};
    flex: 1;
    max-width: ${({ $isSmall }) => ($isSmall ? '48px' : '72px')};
    opacity: ${({ $isFaded }) => ($isFaded ? 0.5 : 1)};

    .team-display {
        justify-content: center;
    }

    img {
        height: 32px;
        width: 48px;
    }
`;
